import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { NgControl } from '@angular/forms';
import { distinctUntilChanged, startWith } from 'rxjs/operators';


@Directive({
  selector: '[hostControl]'
})
export class HostControlDirective implements OnInit{

  constructor(private ngcontrol: NgControl) { }

  @Output() hostemitter: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
    this.ngcontrol.valueChanges.pipe(startWith(this.ngcontrol.value)).subscribe((dat)=>{
      this.hostemitter.emit({host:this.ngcontrol.name,value:this.ngcontrol.value})
    })
  }

  

}
